import React from 'react'
import PropTypes from 'prop-types'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    // In production this should be sent to a logging service (Sentry, etc.)
    // For now, keep it as a simple console error gated by NODE_ENV in the bundler
    // so we can still debug issues during development.
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error('ErrorBoundary caught an error', error, info)
    }
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f5f5f5',
            color: '#333',
            padding: '24px',
            textAlign: 'center'
          }}
        >
          <h1 style={{ fontSize: '24px', marginBottom: '12px' }}>Something went wrong</h1>
          <p style={{ fontSize: '14px', marginBottom: '20px', maxWidth: '420px' }}>
            An unexpected error occurred while rendering this page. You can try reloading the page. If the
            problem persists, please contact support.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              padding: '10px 18px',
              borderRadius: '6px',
              border: 'none',
              cursor: 'pointer',
              backgroundColor: '#1976d2',
              color: '#fff',
              fontSize: '14px',
              fontWeight: '600'
            }}
          >
            Reload page
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
}

export default ErrorBoundary

